const Garfield = {
  level1: '#FFF7E0',
  G50: '#FFF7E0',
  level2: '#FFE9B0',
  G100: '#FFE9B0',
  level3: '#FFDA7D',
  G200: '#FFDA7D',
  level4: '#FFCD47',
  G300: '#FFCD47',
  level5: '#FFC11B',
  G400: '#FFC11B',
  level6: '#FFB700',
  G500: '#FFB700',
  level7: '#FFA900',
  G600: '#FFA900',
  level8: '#FF9600',
  G700: '#FF9600',
  level9: '#FF8400',
  G800: '#FF8400',
  level10: '#FF6300',
  G900: '#FF6300',
};

export { Garfield };
